import script from "./ChatContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatContent.vue?vue&type=script&setup=true&lang=ts"

import "./ChatContent.vue?vue&type=style&index=0&id=d4199e80&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4199e80"]])

export default __exports__